//import { async } from '@firebase/util';
import jwtDecode from 'jwt-decode';
// routes
import { PATH_AUTH } from '../routes/paths';
//
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};


//Added Dirty Token Refresh
const handleTokenExpired = async(exp: number) => {
  let expiredRefreshTokenTimer;
  let expiredTokenTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  var val = localStorage.getItem('refreshTokenExpiryTime');

  var refreshTokenExpiryTime = Date.parse(val!);
  const timeLeftRefresh = refreshTokenExpiryTime*1000 - currentTime;


  console.log(timeLeft);
 

  console.log(timeLeftRefresh);

  clearTimeout(expiredTokenTimer);

  

  clearTimeout(expiredRefreshTokenTimer);


  expiredTokenTimer = await new Promise(resolve => setTimeout(resolve, timeLeft)).then(() => getNewToken());


  // expiredRefreshTokenTimer = setTimeout(() => {
  //   alert('Token expired');

  //   localStorage.removeItem('accessToken');

  //   window.location.href = PATH_AUTH.login;
  // }, timeLeftRefresh);

  expiredRefreshTokenTimer  = await new Promise(resolveRefresh => setTimeout(resolveRefresh, timeLeftRefresh)).then(() => handleExpiredRefreshToken());

  
};

const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode<{ exp: number }>(accessToken); // ~5 days by minimals server
    handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};


async function getNewToken(){

  var token = localStorage.getItem('accessToken');
  var refreshtoken = localStorage.getItem('refreshToken');
  var tenant = String(localStorage.getItem('tenantName'));
  
  const responseAuthorise = await axios.post('/api/tokens/refresh', {
    token,
    refreshtoken,
  }, {
    headers: {
      tenant
    }
  });
  console.log(token);
  const accessToken = responseAuthorise.data;
  localStorage.setItem('refreshToken', accessToken.refreshToken);
  localStorage.setItem('refreshTokenExpiryTime', accessToken.refreshTokenExpiryTime);
  console.log(accessToken.token);
  setSession(accessToken.token);
  
}

async function handleExpiredRefreshToken(){
    alert('Token expired');

    localStorage.removeItem('accessToken');

    window.location.href = PATH_AUTH.login;
}

export { isValidToken, setSession };
